import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../lib/api';
import { PageHeader, Loading, ErrorBox, Badge } from '../components/ui';

export function BannersPage() {
  const qc = useQueryClient();
  const banners = useQuery({ queryKey: ['admin-banners'], queryFn: () => adminApi.banners() });
  const invalidate = () => qc.invalidateQueries({ queryKey: ['admin-banners'] });
  const del = useMutation({ mutationFn: (id: string) => adminApi.bannerDelete(id), onSuccess: invalidate });

  if (banners.isLoading) return <Loading />;
  if (banners.error) return <ErrorBox error={banners.error} />;
  const items = (banners.data as any)?.items ?? [];

  return (
    <div>
      <PageHeader title="App banners" subtitle="Home screen promo slots" />
      <div className="grid grid-cols-3 gap-4">
        {items.map((b: any) => (
          <div key={b.id} className="card overflow-hidden">
            {b.imageUrl && <img src={b.imageUrl} alt={b.name} className="w-full h-28 object-cover" />}
            <div className="p-3">
              <div className="flex items-center justify-between mb-1">
                <span className="font-semibold text-sm">{b.name}</span>
                <Badge tone={b.status === 'active' ? 'success' : 'neutral'}>{b.status}</Badge>
              </div>
              <div className="text-xs mb-2" style={{ color: 'var(--text-faint)' }}>{b.link?.type}: {b.link?.target ?? b.link?.url}</div>
              <button className="btn-outline" style={{ color: 'var(--danger)' }} onClick={() => del.mutate(b.id)}>Delete</button>
            </div>
          </div>
        ))}
        {!items.length && <div className="col-span-3 card p-10 text-center text-sm" style={{ color: 'var(--text-faint)' }}>No banners yet</div>}
      </div>
    </div>
  );
}
